import { Typography } from '@mui/material'
import PropTypes from 'prop-types'

const BreadcrumbActive = ({ title }) => (
  <Typography data-analytics="breadcrumbActive" variant="h1" title={title} lineHeight="inherit">
    {title}
  </Typography>
)

BreadcrumbActive.propTypes = {
  title: PropTypes.string.isRequired,
}

export default BreadcrumbActive
